import api from '@/api';
import localConfig from '@/config';
import { normalizeParamsObject } from 'shared-lib/helpers/formatters';

const types = {
    SAVE_FILTERS: 'SAVE_USERS_FILTERS',
    RESET_FILTERS: 'RESET_USERS_FILTERS',
    RECEIVE_LIST: 'RECEIVE_USERS',
    RECEIVE_DETAILS: 'RECEIVE_USER',
    DELETE_USER: 'DELETE_USER',
};

const initialState = {
    data: {
        data: [],
        meta: {},
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
        },
    },
    user: {},
};

const state = { ...initialState };


const getters = {
    usersData: state => state.data,
    userById: state => id => state.user[id],
};


const actions = {
    saveUsersFilters ({ commit }, payload) {
        commit(types.SAVE_FILTERS, { payload });
    },
    resetUsersFilters ({ commit }) {
        commit(types.RESET_FILTERS);
    },
    getUsers ({ commit }) {
        return api.users.list(state.data.filters).then((response) => {
            commit(types.RECEIVE_LIST, { response });
        });
    },
    getUser ({ commit }, id) {
        return api.users.get(id).then((response) => {
            commit(types.RECEIVE_DETAILS, response.data);
        });
    },
    deleteUser ({ commit }, { id, ...params }) {
        return api.users.delete(id, params).then((response) => {
            commit(types.DELETE_USER, response.data);
        });
    },
};


const mutations = {
    [types.SAVE_FILTERS] (state, { payload }) {
        let payloadNormalized = normalizeParamsObject(payload);
        state.data = {
            ...state.data,
            filters: { ...payloadNormalized },
        };
    },
    [types.RECEIVE_LIST] (state, { response }) {
        state.data = { ...state.data, ...response.data };
    },
    [types.RECEIVE_DETAILS] (state, response) {
        if (response.data && response.data.id) {
            state.user[response.data.id] = response.data;
            state.user = Object.assign({}, state.user);
        }
    },
    [types.DELETE_USER] (state, { data }) {
        if (data && data.id) {
            state.user[data.id] = data;
            state.user = Object.assign({}, state.user);
        }
    },
    [types.RESET_FILTERS] (state) {
        state.data.filters = { ...initialState.data.filters };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
